import { Check, CheckCheck, AlertCircle } from "lucide-react";

/**
 * Confirmação de entrega no padrão do WhatsApp.
 *
 * Só é exibida em mensagens enviadas pelo canal oficial (Meta Cloud API), que é
 * o único que reporta o ciclo real via webhook `statuses`. As stacks não oficiais
 * gravam 'SENT' na hora do envio e nunca atualizam — mostrar um check único e
 * permanente nelas passaria a ideia errada de "não entregue".
 */

export type MessageDeliveryStatus =
  | 'PENDING'
  | 'SENT'
  | 'DELIVERED'
  | 'READ'
  | 'FAILED'
  | (string & {});

interface MessageStatusTicksProps {
  status?: string | null;
  className?: string;
}

export const MessageStatusTicks = ({ status, className = '' }: MessageStatusTicksProps) => {
  const normalized = String(status ?? '').toUpperCase();

  // Enquanto está saindo, o spinner da bolha já sinaliza o envio.
  if (!normalized || normalized === 'PENDING') return null;

  const base = `inline-flex items-center ${className}`;

  switch (normalized) {
    case 'SENT':
      return (
        <span className={base} title="Enviada" aria-label="Enviada">
          <Check className="w-3.5 h-3.5 text-muted-foreground dark:text-neutral-300" />
        </span>
      );
    case 'DELIVERED':
      return (
        <span className={base} title="Entregue" aria-label="Entregue">
          <CheckCheck className="w-3.5 h-3.5 text-muted-foreground dark:text-neutral-300" />
        </span>
      );
    case 'READ':
      return (
        <span className={base} title="Lida" aria-label="Lida">
          <CheckCheck className="w-3.5 h-3.5 text-[#2563EB] dark:text-[#60A5FA]" />
        </span>
      );
    case 'FAILED':
      return (
        <span className={base} title="Falhou" aria-label="Falhou">
          <AlertCircle className="w-3.5 h-3.5 text-red-500 dark:text-red-400" />
        </span>
      );
    default:
      return null;
  }
};
